import { Link } from "react-router-dom";
import { scrollToTop } from "./ScrollToTop";

interface LogoProps {
  light?: boolean;
}

export default function Logo({ light = false }: LogoProps) {
  return (
    <Link to="/" onClick={scrollToTop} className="flex items-center gap-2.5 cursor-pointer" aria-label="비앙카 피부관리 홈">
      <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
        <i className="ri-flower-line text-white text-xl"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`text-lg font-bold font-heading whitespace-nowrap ${light ? "text-white" : "text-foreground-900"}`}>
          비앙카
        </span>
        <span className={`text-[10px] tracking-[0.28em] font-brand uppercase whitespace-nowrap ${light ? "text-white/80" : "text-primary-500"}`}>
          Bianca Skin
        </span>
      </span>
    </Link>
  );
}